module.exports = __webpack_public_path__ + "img/top.9a59f864.png";